<template>
    <page @click="() => (batchSetData = '', editImage = '')">
        <module :title="id ? (detail?'编辑详情':'编辑服务') : '发布服务'" :sub-title="compClassifyName">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item v-model="salesModel" type="radio" label="销售模式" name="sales_model" :options="salesModelOptions" v-show="false"
                                 required :disabled="this.id && productState != 0 && !!product_sales_model" :word="salesModelWord">
                    </c-form-item>
                    <c-form-item type="input" label="服务标题" name="product_name" required></c-form-item>
                    <c-form-item type="input" label="服务卖点" name="product_subtitle"></c-form-item>
                    <c-form-item v-show="flowList.length"  label="服务流程">
						<div class="flex" style="padding: 0 30px;">
							<node-list :nodes="flowList"></node-list>
						</div>
					</c-form-item>
                    <c-form-item label="所需材料" name="order_materials" required>
						<c-form-item v-show="!detail" v-model="orderMaterials" :label="false" type="checkbox" :options="orderMaterialsOptions"></c-form-item>
						<c-form-item v-show="!detail" v-model="orderMaterialsCustom" :label="false" type="textarea" maxlength="500" placeholder="可填写额外的材料信息，最多500个字符"></c-form-item>
						<div v-show="orderMaterialsPrevie" class="materials">{{orderMaterialsPrevie}}</div>
					</c-form-item>
                    <!-- <c-form-item type="input" label="服务货号" name="product_itemnumber"
                                 :required="systemConfig.product_number_required == 'ON' || systemConfig.product_sku_code_autocreate_type == 'productnumberseq'"></c-form-item> -->
                    <!-- <c-form-item type="select" label="服务品牌" name="product_brand_id"
                                 :options="productBrandOptions"></c-form-item> -->
                    <!-- <c-form-item v-if="systemConfig.share_enable == 'ON'" type="checkbox" label="可售范围"
                                 name="visible_user_level" v-model="visibleUserLevel" :options="userLevelOptions" required
                                 word="选中则表示该等级会员可查看、可下单"></c-form-item> -->
					
					<c-form-item v-model="region_type" type="radio" label="服务区域" name="region_type" :options="regionTypeOptions" v-show="operationMode == 1 || operationMode == 3" required>
					</c-form-item>
					
					<c-form-item :label="region_type_name" v-show="region_type != 1 && (operationMode == 1 || operationMode == 3)" required>
						<power-tree :power-list="powerList" style="width: 1200px;height:500px;"></power-tree>
					</c-form-item>
					
					<div style="width:1015px;" v-if="!(operationMode == 1 || operationMode == 3)">
						<div style="color:#666; margin-left:40px; width:60px; display: inline-block; vertical-align: top;">可售区域</div>
						<div style="margin-left:8px; border:solid 1px #ddd; height:100px; width:890px; display: inline-block;padding:3px;">
							<span v-if="productDetail.region_type == 1" style="color:green">全国可售</span>
							<span v-if="productDetail.region_type == 2">{{productDetail.region_names}}</span>
							<span v-if="productDetail.region_type == 3">全国可售，以下地区除外（<span style="color:red">{{productDetail.region_names}}</span>）</span>
						</div>
					</div>
                    <c-form-item v-show="systemConfig.share_enable == 'ON' && systemConfig.region_subsidy_enable == 'ON'" type="radio" label="区域奖励"
                                 name="region_subsidy" v-model="regionSubsidy" :options="regionSubsidyOptions" required
                                 word="注：奖励存在，则根据购买当前服务的订单的“收货地址”，匹配相关区域，匹配到的区域负责人可获得奖励"></c-form-item>
                    <c-form-item v-show="systemConfig.share_enable == 'ON' && systemConfig.region_subsidy_enable == 'ON' && regionSubsidy == 1" type="number" decimal="2" :limit="[0,9999]"
                                 label="省级奖励" name="province_subsidy" input-unit="元"
                                 word="注：即每成交一件当前服务SKU，省级代理可获得的奖励金额；不填写则默认0，即无奖励"></c-form-item>
                    <c-form-item v-show="systemConfig.share_enable == 'ON' && systemConfig.region_subsidy_enable == 'ON' && regionSubsidy == 1" type="number" decimal="2" :limit="[0,9999]"
                                 label="市级奖励" name="city_subsidy" input-unit="元"
                                 word="注：即每成交一件当前服务SKU，城市级代理可获得的奖励金额；不填写则默认0，即无奖励"></c-form-item>
                    <c-form-item v-show="systemConfig.share_enable == 'ON' && systemConfig.region_subsidy_enable == 'ON' && regionSubsidy == 1" type="number" decimal="2" :limit="[0,9999]"
                                 label="区县级奖励" name="county_subsidy" input-unit="元"
                                 word="注：即每成交一件当前服务SKU，区县级代理可获得的奖励金额；不填写则默认0，即无奖励"></c-form-item>
                    <c-form-item type="number" v-show="false" label="卡券有效期" v-model="effectiveMonths"
                                 name="effective_months" decimal="0" :limit="[1,9999]"
                                 required input-unit="月"
                                 word="下单支付后，自动生成的消费卡券在该期限内有效，超期则自动失效"></c-form-item>
                    <c-form-item type="radio" v-show="false" label="超期未消费" v-model="expireCardRefund" 
                                 name="expire_card_refund" :options="expireCardRefundOption" required
                                 word="卡券超期时效后是否退还购买卡券的金额（注：该配置在产生卡券时即固定，修改配置对已生成的卡券无效）"></c-form-item>
                    <c-form-item v-show="attrConfig.length" label="服务属性" name="product_attr_list">
                        <div class="box params">
                            <c-form ref="attrForm" item-width="50%" inline>
                                <c-form-item v-for="(item, i) in attrConfig" :key='i' :type="item.parameter_type"
                                             :label="item.parameter_name" :name="item.id"
                                             :options="item.parameter_values"
                                             :required="item.required_flag == 2"></c-form-item>
                            </c-form>
                        </div>
                    </c-form-item>
                    <c-form-item v-show="paramConfig.length" label="服务参数" name="product_paramter_list">
                        <div class="box params">
                            <c-form ref="paramForm" item-width="50%" inline>
                                <c-form-item v-for="(item, i) in paramConfig" :key='i' :type="item.parameter_type"
                                             :label="item.parameter_name" :name="item.id"
                                             :options="item.parameter_values"
                                             :required="item.required_flag == 2"></c-form-item>
                            </c-form>
                        </div>
                    </c-form-item>
                    <c-form-item v-model="imageScale" type="radio" label="服务主图" name="product_img_type"
                                 :options="imageScaleOptions" required></c-form-item>
                    <c-form-item type="image" name="product_img_list" oss limit="5"
                                 word="主图大小不能超过3MB，3:4的比例（建议尺寸750*1000），1:1的比例（建议尺寸800*800）"
                                 :inline-word="false"></c-form-item>
                    <c-form-item v-show="imageScale == 1" type="image" label="1:1主图" oss
                                 file-word="请上传一张1:1主图<br>1:1主图将显示在服务列表、收藏夹及历史足迹等页面"
                                 name="product_square_img" required></c-form-item>
                    <c-form-item type="video" label="服务视频" name="product_video_url" oss
                                 file-word="视频格式：MP4<br>视频支持1:1，16:9，最长不超过60秒，突出1-2个核心卖点；文件大小不超过30M。"></c-form-item>
                    <c-form-item label="服务描述">
                        <div class="box detail flex">
                            <dl class="detail-preview">
                                <dt>页面预览</dt>
                                <dd>
                                    <template v-for="(item, i) in detailList">
                                        <img v-if="item.type == 'image'" :key="i" :src="item.content">
                                        <div v-else :key="i">{{ item.content }}</div>
                                    </template>
                                </dd>
                            </dl>
                            <div class="detail-edit flex-grow">
                                <p class="tips">支持图片和文本，最多可插入50条内容，已插入<b>{{ detailList.length }}</b>/50条，拖拽可调整顺序
                                </p>
                                <div class="flex-wrap">
                                    <draw-sort v-model="detailList" class="flex-wrap">
                                        <template v-slot="{item, id, index}">
                                            <draw-item :key="id" :index="index">
                                                <div class="detail-edit-item flex-center">
                                                    <img v-if="item.type == 'image'" :src="item.content">
                                                    <div v-else class="text">
                                                        <p>{{ item.content }}</p>
                                                    </div>
                                                    <div class="handle flex" @mousedown.stop>
                                                        <a v-if="item.type == 'text'" style="background: #0060EF;"
                                                           @click="insertDetailItem('text', item, index)"><i
                                                                class="tf tf-edit"></i></a>
                                                        <a style="background: #F30000;" @click="delDetailItem(index)"><i
                                                                class="tf tf-cross"></i></a>
                                                    </div>
                                                </div>
                                            </draw-item>
                                        </template>
                                        <div slot="append" class="detail-edit-item insert flex-column flex-center-main">
                                            <c-button @click="insertDetailItem('image')">插入图片</c-button>
                                            <c-button @click="insertDetailItem('text')">插入文本</c-button>
                                        </div>
                                    </draw-sort>
                                </div>
                            </div>
                        </div>
                    </c-form-item>
					
                    <c-form-item v-if="!singleSkuMode" label="SKU配置" required :inline-word="false">
                        <div class="spec-list">
                            <div v-for="(spec, i) in specList" :key="i" class="box spec">
                                <div class="flex-center-cross">
                                    <span class="spec-name">{{ spec.name }}</span>
                                </div>
                                <div class="spec-item-list">
                                    <draw-sort v-model="spec.itemList" class="flex-wrap">
                                        <template v-slot="{item, id, index}">
                                            <draw-item :key="id" :index="index" :handle-style="{
												'position': 'absolute',
												'left': '100%',
												'top': '0',
												'width': '20px',
												'line-height': '20px',
												'font-size': '12px',
												'text-align': 'center',
												'background': '#ddd'
											}" style="margin: 12px 32px 0 0;">
                                                <div class="spec-item flex-center-cross">
                                                    <template v-if="spec.image">
                                                        <div v-for="(img, k) in specData[item.id].image" :key="k"
                                                             class="spec-item-img"
                                                             :style="{'z-index': editImage == img ? 2 : 1}" @click.stop
                                                             @mouseenter="editImage = img">
                                                            <div class="main flex-center"
                                                                 @click="delSpecItemImage(item, k)">
                                                                <img :src="img.img" alt="">
                                                                <p class="ellipsis">{{ img.name }}</p>
                                                                <a class="delete flex-center"><i
                                                                        class="tf tf-cross"></i></a>
                                                            </div>
                                                            <div v-show="editImage == img" class="preview-box">
                                                                <div class="preview">
                                                                    <c-image class="image" :src="img.img"></c-image>
                                                                    <c-input v-model="img.name" class="input"
                                                                             maxlength="6"
                                                                             placeholder="图片描述(最多6个字)"></c-input>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="specData[item.id].image.length < 5"
                                                             class="spec-item-img flex-center">
                                                            <div class="main flex-center"
                                                                 @click="setSpecItemImage(item)">
                                                                <i class="tf tf-plus"></i>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <input v-model="specData[item.id].value"
                                                           class="spec-item-value flex-grow" type="text"
                                                           @change="specValueVerify(item.id, spec.itemList)">
                                                    <a v-show="spec.itemList.length > 1"
                                                       class="spec-item-remove tf tf-clear"
                                                       @click="removeItem(spec, index)"></a>
                                                </div>

                                                <template #handle>
                                                    <div><i class="tf">&#xe688;</i></div>
                                                </template>
                                            </draw-item>
                                        </template>
                                    </draw-sort>
                                </div>
                                <c-button background="#4A528D" icon="add" @click="addSpecItem(spec)">添加规格值
                                </c-button>
                                <a v-if="spec.new" v-show="specList.length > 1" class="spec-remove"
                                   @click="removeSpec(i)"><i class="tf tf-trash"></i></a>
                            </div>
                        </div>
                    </c-form-item>
                    
					<c-form-item v-model="currentSkuCode" v-show="false" label="SKU编码" name="product_sku_code_create_type"
                                 type="radio" :options="skuCodeType" required :disabled="!!id"
                                 :word="systemConfig.order_push_enabled == 'ON' ? '当前商档将自动推送第三方' : ''"></c-form-item>
								 
                    <c-form-item v-if="!singleSkuMode" label="价格及库存" required>
                        <div class="sku-detail">
                            <table class="detail-table">
                                <thead>
                                <tr>
                                    <th v-for="(spec, i) in specList" :key="i">{{ spec.name }}</th>
                                    <th><b>*</b>销售价(元)<a @click.stop="batchSetSku('price', '销售价', $event)"><i
                                            class="tf tf-edit"></i></a></th>
                                    <th><b>*</b>库存(件)<a @click.stop="batchSetSku('stock', '库存', $event)"><i
                                            class="tf tf-edit"></i></a></th>
                                    <!--										<th>划线价<a @click.stop="batchSetSku('oldPrice', '划线价', $event)"><i class="tf tf-edit"></i></a></th>-->
                                    <th v-if="skuPrivateImage">预览图</th>
                                    <th>重量(kg)<a @click.stop="batchSetSku('weight', '重量', $event)"><i
                                            class="tf tf-edit"></i></a></th>
                                    <th style="width:160px;">
                                        <b>*</b>SKU编码{{ currentSkuCode == 1 ? '（自动生成）' : '' }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="skuList.length == 0">
                                    <td :colspan="specList.length + 6">暂无规格信息</td>
                                </tr>
                                <template v-else>
                                    <tr v-for="(row, i) in skuList" :key="i">
                                        <template v-for="(col, j) in row">
                                            <td v-if="rowspan(i, j)" :rowspan="rowspan(i, j)">
                                                {{ specData[col].value }}
                                            </td>
                                        </template>
                                        <td>
                                            <c-input v-model="skuData[row.join(',')].price" type="number" decimal="2"
                                                     height="30"></c-input>
                                        </td>
                                        <td>
                                            <c-input v-model="skuData[row.join(',')].stock" type="number" height="30"
                                                     :disabled="!skuData[row.join(',')].new"></c-input>
                                        </td>
                                        <!--											<td>-->
                                        <!--												<c-input v-model="skuData[row.join(',')].oldPrice" type="number" decimal="2" height="30"></c-input>-->
                                        <!--											</td>-->
                                        <td v-if="skuPrivateImage">
                                            <div class="sku-image flex-center-cross">
                                                <div v-for="(img, k) in skuData[row.join(',')].image" :key="k"
                                                     class="image" @click.stop @mouseenter="editImage = img">
                                                    <div class="main flex-center"
                                                         @click="delSkuImage(row.join(','), k)">
                                                        <img :src="img.img">
                                                        <p class="ellipsis">{{ img.name }}</p>
                                                        <a class="delete flex-center"><i class="tf tf-cross"></i></a>
                                                    </div>
                                                    <div v-show="editImage == img" class="preview-box">
                                                        <div class="preview">
                                                            <c-image class="image" :src="img.img"></c-image>
                                                            <c-input v-model="img.name" class="input" maxlength="6"
                                                                     placeholder="图片描述(最多6个字)"></c-input>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="skuData[row.join(',')].image.length < 5" class="image"
                                                     @click="setSkuImage(row.join(','))">
                                                    <div class="main flex-center">
                                                        <i class="tf tf-plus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <c-input v-model="skuData[row.join(',')].weight" type="number" decimal="2"
                                                     height="30"></c-input>
                                        </td>
                                        <td>
                                            <c-input v-model="skuData[row.join(',')].code" height="30"
                                                     :disabled="currentSkuCode == 1"></c-input>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                            <div class="total">总库存：{{ totalStock }}件</div>
                        </div>
                    </c-form-item>
                
					<template v-else>
						<c-form-item v-model="skuData.product_sku_code" type="input" label="编码" required :disabled="currentSkuCode == 1" v-show="false"></c-form-item>
                        <c-form-item v-model="priceModue" type="radio" label="价格模式"
                                     name="price_modue" :options="priceModueOption"
                                     word="设置“价格面议”，则用户下单无金额，需要商家对订单手动“调价”后才能进行后续操作">
                        </c-form-item>
						<c-form-item v-model="skuData.product_price" v-show="priceModue == 1" type="number" decimal="2" label="销售价" :limit="[0.01,99999999]" required></c-form-item>
                        <c-form-item v-model="priceUnit" type="select" label="价格单位" name="price_unit" options="PRICE_UNIT"
                                     word="即单次收费后服务持续时间，例如：次、年、季度等"></c-form-item>

                        <c-form-item v-model="skuData.product_sku_stock" type="number" label="库存" required></c-form-item>
						<!-- <c-form-item v-model="skuData.product_weight" type="number" decimal="2" label="重量" ></c-form-item> -->
					</template>
				</c-form>

                <c-form title="其他设置">
                    <c-form-item v-if="systemConfig.is_outstock == 'ON'"
                                 v-model="productIsOutstock" type="radio" label="缺货订购"
                                 name="is_outstock" :options="isOutstockOptions"
                                 word="服务支持缺货订购，则表示在无库存的情况下平台用户也可以正常下单购买该服务">
                    </c-form-item>
                    <c-form-item label="是否定制" width="1000" v-show="systemConfig.product_custom == 'ON'">
                        <c-radio-group v-model="productCustom" name="is_custom">
                            <c-radio value="0">否</c-radio>
                            <c-radio value="1">支持定制</c-radio>
                        </c-radio-group>

                        <div v-show="productCustom == 1" style="padding: 10px 0;">
                            <c-form-item v-show="customTempList" v-model="currentCustomTemp" label="定制历史记录"
                                         type="select" :options="customTempList"></c-form-item>

                            <c-form-item label="选择定制项" width="600">
                                <c-checkbox-group v-model="currentCustomItem">
                                    <c-checkbox v-for="(item, i) in customItem" :key="i" :value="item.item_id">
                                        {{ item.item_name }}
                                    </c-checkbox>
                                </c-checkbox-group>
                            </c-form-item>

                            <div v-show="currentCustomItem.length" class="box detail custom-detail"
                                 style="margin-bottom: 16px;">
                                <ul class="flex custom-item">
                                    <li v-for="(item, i) in currentCustomItemData" :key="i"
                                        :class="{'z-crt': item.item_id == currentCustomItemTab}"
                                        @click="currentCustomItemTab = item.item_id">{{ item.item_name }}
                                    </li>
                                </ul>
                                <div v-for="(custom, i) in currentCustomItemData" :key="i"
                                     v-show="currentCustomItemTab == custom.item_id">
                                    <template v-if="custom.item_type == 1">
                                        <table class="detail-table">
                                            <thead>
                                            <tr>
                                                <th style="width: 300px;">定制位置</th>
                                                <th style="width: 300px;">工艺</th>
                                                <th style="width: 150px;"><b>*</b>最小起订量<a
                                                        @click.stop="batchSetCustom('min_custom_count', '起订量', custom, $event)"><i
                                                        class="tf tf-edit"></i></a></th>
                                                <th style="width: 150px;"><b>*</b>加价<a
                                                        @click.stop="batchSetCustom('product_price_cost', '加价', custom, $event)"><i
                                                        class="tf tf-edit"></i></a></th>
                                                <th style="width: 80px;">操作</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <template v-for="(item, j) in custom.list">
                                                <tr :key="j">
                                                    <td v-if="customPositionCell(custom.list, j)"
                                                        :rowspan="customPositionCell(custom.list, j)">
                                                        <div class="position flex-column flex-center">
                                                            <c-image class="position-image"
                                                                     :src="item.position_image_url"></c-image>
                                                            <p>{{ item.position_name }}</p>
                                                        </div>
                                                    </td>
                                                    <td v-if="!item.tech_id" colspan="4">未选择工艺</td>
                                                    <template v-else>
                                                        <td>{{ item.tech_name }}</td>
                                                        <td>
                                                            <c-input v-model="item.min_custom_count"
                                                                     type="number"></c-input>
                                                        </td>
                                                        <td>
                                                            <c-input v-model="item.product_price_cost" type="number"
                                                                     decimal="2"></c-input>
                                                        </td>
                                                        <td><a class="remove"
                                                               @click="deleteCustomItemOption(custom, j, item.position_id)">删除</a>
                                                        </td>
                                                    </template>
                                                </tr>
                                                <tr v-if="customPositionAdd(custom.list, j)" :key="`${j}add`">
                                                    <td colspan="4">
                                                        <a class="s-link" @click="addCustomItemOption(custom, item, j)">添加工艺</a>
                                                        <a class="remove" style="margin-left: 15px;"
                                                           @click="deleteCustomItemOption(custom, 'all', item.position_id)">删除位置</a>
                                                    </td>
                                                </tr>
                                            </template>
                                            </tbody>
                                        </table>
                                        <c-button color="main" @click="addCustomItemOption(custom)">添加定制位置
                                        </c-button>

                                        <c-dialog ref="customPositionDialog" title="添加定制位置" width="800"
                                                  height="440" @resolve="addCustomItemOptionHandle">
                                            <div class="custom-option">
                                                <c-button hollow @click="customOptionAllCheckHandle">全选</c-button>
                                                <c-checkbox-group v-if="custom.position" ref="customPosition">
                                                    <div class="position-list flex-wrap">
                                                        <div v-for="(item, i) in custom.position" :key="i"
                                                             class="position">
                                                            <c-image class="position-image"
                                                                     :src="item.img_url"></c-image>
                                                            <div class="position-check">
                                                                <c-checkbox :value="item.id" :disabled="item.checked">
                                                                    {{ item.name }}
                                                                </c-checkbox>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </c-checkbox-group>
                                            </div>
                                        </c-dialog>
                                        <c-dialog ref="customTechnicsDialog" title="添加工艺" width="600" height="240"
                                                  @resolve="addCustomItemOptionHandle">
                                            <div class="custom-option">
                                                <c-button hollow @click="customOptionAllCheckHandle">全选</c-button>
                                                <c-checkbox-group v-if="custom.technics" ref="customTechnics">
                                                    <c-checkbox v-for="(item, i) in custom.technics" :key="i"
                                                                :value="item.id" :disabled="item.checked">
                                                        {{ item.name }}
                                                    </c-checkbox>
                                                </c-checkbox-group>
                                            </div>
                                        </c-dialog>
                                    </template>

                                    <template v-else>
                                        <table class="detail-table">
                                            <thead>
                                            <tr>
                                                <th style="width: 200px;">{{ custom.item_name }}</th>
                                                <th v-if="custom.item_type == 3" style="width: 200px;">颜色色值</th>
                                                <th style="width: 150px;"><b>*</b>最小起订量<a
                                                        @click.stop="batchSetCustom('min_custom_count', '起订量', custom, $event)"><i
                                                        class="tf tf-edit"></i></a></th>
                                                <th style="width: 150px;"><b>*</b>加价<a
                                                        @click.stop="batchSetCustom('product_price_cost', '加价', custom, $event)"><i
                                                        class="tf tf-edit"></i></a></th>
                                                <th style="width: 80px;">操作</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, j) in custom.list" :key="j">
                                                <td>{{ item.param_value }}</td>
                                                <td v-if="custom.item_type == 3">
                                                    <div class="flex-center-cross color">
                                                        <div>
                                                            <div :style="{'background': item.param_code}"></div>
                                                        </div>
                                                        <span>{{ item.param_code }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <c-input v-model="item.min_custom_count" type="number"></c-input>
                                                </td>
                                                <td>
                                                    <c-input v-model="item.product_price_cost" type="number"
                                                             decimal="2"></c-input>
                                                </td>
                                                <td><a class="remove"
                                                       @click="deleteCustomItemOption(custom, j)">删除</a></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <c-button color="main" @click="addCustomItemOption(custom)">
                                            添加{{ custom.item_name }}项
                                        </c-button>

                                        <c-dialog :ref="`customOptionDialog${custom.item_id}`"
                                                  :title="`添加${custom.item_name}项`" width="600" height="240"
                                                  @resolve="addCustomItemOptionHandle">
                                            <div class="custom-option">
                                                <c-button hollow @click="customOptionAllCheckHandle">全选</c-button>
                                                <c-checkbox-group v-if="custom.option"
                                                                  :ref="`customOption${custom.item_id}`">
                                                    <c-checkbox v-for="(item, i) in custom.option" :key="i"
                                                                :value="item.id" :disabled="item.checked">
                                                        {{ item.name }}
                                                    </c-checkbox>
                                                </c-checkbox-group>
                                            </div>
                                        </c-dialog>
                                    </template>
                                </div>
                            </div>

                            <c-form-item label="定制说明" type="textarea" name="custom_remark"></c-form-item>
                        </div>
                    </c-form-item>
                    <c-form-item v-model="purchase_limit_type" type="radio" label="限购方式" required
                                 name="is_gift_package" :options="purchaseLimitTypeOptions"
                                 required
                                 word="待支付未关闭或已支付订单服务计入购买量，订单服务完成退款或退货后，则从限购数量中减去；定制下单也同样适用限购规则">
                    </c-form-item>
                    <c-form-item type="number" label="限购数量" name="purchase_max_count" v-model="purchase_max_count"
                                 v-if="purchase_limit_type!=0" required :limit="[1,999999999]"></c-form-item>
                    <c-form-item v-model="salesDate" type="radio" label="上架设置" name="product_first_sell_type"
                                 :options="salesDateOptions" required></c-form-item>
                    <c-form-item v-show="salesDate == 3" type="datetime" label="上架时间" name="auto_sell_date"
                                 required></c-form-item>
                    <c-form-item v-if="isVirtual == 0" type="select" label="运费模板" name="freight_template_id"
                                 :options="freightTmplOptions" required>
                        <span slot="word"><a class="s-link" @click="getFreightTmpl()">刷新&nbsp;&nbsp;</a></span>
                        <span slot="word">如果没有运费模板，点击这里<a class="s-link" @click="navigateTo('/freight_template')">去创建</a></span>
                    </c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button power="b_product_edit" v-if="this.operationMode == 1 || this.operationMode == 3" size="m"
                          @click="submit(productState == 0 ? 2 : 3)">提交发布</c-button>
                <c-button power="b_product_edit" v-if="productState == 0 && this.operationMode == 1 || this.operationMode == 3" size="m" hollow
                          @click="submit(1)">暂存草稿</c-button>
                <c-button power="b_product_audit_list_audit" v-if="productState == 3 && detail" size="m" color="black"
                          hollow @click="auditHandle('pass', productDetail)">审批通过</c-button>
                <c-button power="b_product_audit_list_audit" v-if="productState == 3 && detail" size="m" color="red"
                          hollow @click="auditHandle('reject', productDetail)">审批驳回</c-button>
            </template>

            <div v-show="batchSetData" ref="batchSet" class="batch-set"
                 :style="{'top': batchSetData.top, 'left': batchSetData.left}" @click.stop>
                <p>批量填写{{ batchSetData.name }}</p>
                <div class="flex">
                    <c-input v-model="batchSetData.value" ref="batchSetInput" type="number"
                             :decimal="batchSetData.decimal" @keyup.native.enter="batchSetHandle"></c-input>
                    <c-button color="sys" height="30" @click="batchSetHandle">确定</c-button>
                </div>
            </div>

            <c-dialog ref="detailText" title="插入文本" width="500" @resolve="insertDetailText">
                <div class="detail-text-edit">
                    <textarea v-model="detailEditText"></textarea>
                </div>
            </c-dialog>
        </module>
        <!--审批通过 - 服务价格设置弹窗-->
        <edit-product-sku-price ref="editProductSkuPrice" @resolve="auditProductHandle"></edit-product-sku-price>
        <!--审批驳回 - 弹窗-->
        <c-dialog ref="auditRejectDialog" title="服务审批" width="500" height="400" @resolve="auditProductHandle">
            <c-form>
                <c-form-item v-model="rejectReason" type="select" label="驳回原因" name="reject_reason" options="PRODUCT_REJECT_REASON"
                              word="请选择驳回该服务的原因"></c-form-item>
                <c-form-item v-model="rejectReasonRemark" type="textarea" label="备注" name="reject_reason_remark"
                             word="请输入驳回原因的备注信息，该信息将附加在驳回原因之后，最多可输入100个字符" maxlength="100"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import nodeList from '@/components/public/node_list.vue'
import drawSort from '@/components/draw_sort_new/index.vue'
import drawItem from '@/components/draw_sort_new/item.vue'
import editProductSkuPrice from "@/components/service/edit_product_sku_price.vue";

function getStyleComputedProperty(element, property) {
    var css = window.getComputedStyle(element, null);
    return css[property];
}

function getScrollParent(element, fun) {
    var parent = element.parentNode;

    if (!parent) {
        return;
    }
    if (parent === window.document) {
        if (window.document.body.scrollTop || window.document.body.scrollLeft) {
            return fun(window.document.body);
        } else {
            return fun(window);
        }
    }

    if (
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 ||
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 ||
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1
    ) {
        fun(parent);
    }
    return getScrollParent(element.parentNode, fun);
}

function renderPower(h, list, parent) {
		var arr = [], last = !list.find(item => item.children.length);
		list.map(item => {
			item.parent = parent;
			arr = arr.concat([
				<div class="power-item" style={`float: ${last ? 'left' : 'none'}`}>
					<c-checkbox checked={item.chk != 0} on-click={$event => this.checkHandle(item, $event)}>{item.name}</c-checkbox>
					{
						item.children.length ? [
							<div class="power-list">
								{
									renderPower.call(this, h, item.children, item)
								}
							</div>
						] : []
					}
				</div>
			]);
		});
		
		return arr;
	}
	
	const powerTree = {
		render(h) {
			return (
				<div class="power">
					{
						renderPower.call(this, h, this.powerList)
					}
				</div>
			)
		},
		
		props: {
			powerList: Array
		},
		
		methods: {
			checkHandle(power, state) {
				state = state ? 1 : 0;
				
				power.chk = state;
				!function poll(list) {
					list.forEach(item => {
						item.chk = state;
						poll(item.children);
					});
				}(power.children);
				
				!function poll(parent) {
					if (parent) {
						//任何一个子节点被选中，父节点选中逻辑
						//parent.chk = parent.children.find(item => !!item.chk) ? 1 : 0;
						
						// 所有子节点被选中，父节点选中逻辑
						const allChildrenChecked = parent.children.every(item => item.chk === 1);
						// 父节点状态：所有子节点都选中则为1，否则为0
						parent.chk = allChildrenChecked ? 1 : 0;
						
						poll(parent.parent);
					}
				}(power.parent);
			}
		}
	};

export default {
    name: 'product_edit',

    components: {
		nodeList,
        editProductSkuPrice,
        drawSort,
        drawItem,
		powerTree
    },

    props: {
        classify: String,
        classifyName: String,
        id: String,
        detail: String
    },

    data() {
        return {
            salesModel:1,
            product_sales_model: undefined,//服务数据中的sales_model，仅编辑服务是有数据
            salesModelOptions: [
                {name: '供货',value: 1},
                {name: '直销',value: 2}
            ],
            visibleUserLevel:[],//服务可售范围
			regionTypeOptions: [
				{name: '全国可售',value: 1},
				{name: '按可售区域配置',value: 2},
				{name: '按不可售区域配置',value: 3}
			],
            regionSubsidy:0,    //区域负责人，是否有奖励
            regionSubsidyOptions: [
                {name: '无奖励', value: 0},
                {name: '有奖励', value: 1}
            ],
            productDetail: {},
            operationMode: 1,
            productState: 0, //服务状态（0-草稿 1-下架 2-上架 3-待审批 4-已驳回）
            productClassify: '',
            productClassifyName: [],

            paramConfig: [],
            attrConfig: [],
            paramValue: {},
            attrValue: {},

            detailList: [],
            detailEditText: '',

            imageScaleOptions: [
                {name: '1:1',value:2},
                {name: '3:4',value:1}
            ],
            imageScale: 2,
            skuCodeType: [
                {name: '自动生成',value:1},
                {name: '手动填写',value:2}
            ],
            currentSkuCode: 1,
            salesDateOptions: [
                {name: '立即上架', value: 2},
                {name: '手动上架', value: 1}
                // ,{name: '定时上架', value: 3}
            ],
            salesDate: 2,
            freightTmplOptions: [],//运费模板数据集合
            productBrandOptions: [],//服务品牌数据集合
            userLevelOptions: [],//用户等级数据集合
			
			singleSkuMode: true,
            specIndex: 0,
            specList: [],
            specData: {},
            skuData: {},
            skuPrivateImage: false,

            productCustom: 0,
            customTempList: '',
            currentCustomTemp: '',
            customItem: [],
            currentCustomItem: [],
            currentCustomItemTab: '',

            editImage: '',
            batchSetData: '',
            purchase_limit_type: 0,
            purchase_max_count: 0,
            purchaseLimitTypeOptions: [
                {name: '不限购', value: 0},
                {name: '终身限购', value: 1},
                {name: '按单限购', value: 2}
            ],
            isOutstockOptions: [
                {name: '不支持', value: 1},
                {name: '支持', value: 2}
            ],
			isVirtual: 0,
            isVirtualOption: {
                0: '实物服务',
                1: '虚拟服务'
            },
            productIsOutstock: 1,  //是否支持缺货订购(1-不支持 2-支持)
            effectiveMonths: 12,
            auditStateOptions: [
                {name: '审批通过', value: 1},
                {name: '审核驳回', value: 2}
            ],
            auditState: 1,
            auditType: '',
            isCustom: 0,
            optionType: 1,
            expireCardRefund: 1,//卡券到期未消费处理方式 1=不退款 ；2=退款
            expireCardRefundOption: [
                {name: '不退款', value: 1},
                {name: '退款', value: 2},
            ],
            rejectReason:'',
            rejectReasonRemark:'',
            priceModue:1,    //1=预设售价 2=价格面议
            priceUnit:'',    //售价单位
            priceModueOption:[
                {name: '预设售价',value: 1},
                {name: '价格面议',value: 2},
            ],
			region_type_name: '销售区域明细',
			region_type: 1,
			powerList: [],
			flowList: [],
			orderMaterialsOptions: [],
			orderMaterials: [],
			orderMaterialsCustom: ''
        }
    },

    computed: {
        ...mapState(['systemConfig']),

        compClassifyName() {
            var virtualName = `类目：${this.id ? this.productClassifyName.join(' ➩ ') : this.classifyName.split(',').join(' > ')}`;
            if (this.systemConfig.is_virtual_product == 'ON'){
                virtualName = virtualName + `【${this.isVirtualOption[this.isVirtual]}】`;
            }
            return virtualName;
        },

		orderMaterialsPrevie() {
			if (this.orderMaterials.length) {
				return this.orderMaterials.map(id => {
					let option = this.orderMaterialsOptions.find(item => item.value == id);
					return option ? option.remark : '';
				}).filter(item => item).concat(this.orderMaterialsCustom.trim() ? [this.orderMaterialsCustom.trim()] : []).map((item, index) => {
					return `${index + 1}. ${item}`;
				}).join('\n');
			} else {
				return this.orderMaterialsCustom.trim();
			}
		},

        skuList() {
            var that = this, skuList = [];
            !function poll(index, tree, isNew) {
                let list = that.specList[index];
                if (!list) {
                    if (tree) {
                        if (!that.skuData[tree]) {
                            // var specImg = tree.split(',').find(item => that.specData[item].image);
                            that.$set(that.skuData, tree, {
                                id: `sku${that.specIndex++}`,
                                price: '',
                                stock: '',
                                // oldPrice: '',
                                image: [],
                                weight: '',
                                code: '',
                                new: isNew
                            });
                        }
                        skuList.push(tree.split(','));
                    }
                    return;
                }
                list.itemList.forEach(item => {
                    let t = tree ? tree.split(',') : [];
                    t.push(item.id);
                    poll(index + 1, t.join(','), isNew ? isNew : item.new);
                });
            }(0);

            return skuList;
        },

        rowspan() {
            return (row, col) => {
                var count = 1;
                for (let i = col + 1; i < this.specList.length; i++) {
                    count *= this.specList[i].itemList.length;
                }

                return row % count ? 0 : count;
            }
        },

        totalStock() {
            var total = 0;
            this.skuList.forEach(row => {
                total += parseInt(this.skuData[row.join(',')].stock) || 0;
            });
            return total;
        },

        currentCustomItemData() {
            return this.customItem.filter(item => this.currentCustomItem.includes(item.item_id));
        },

        customPositionCell() {
            return (list, i) => {
                if (i == 0 || list[i - 1].position_name != list[i].position_name) {
                    return list.filter(item => item.position_name == list[i].position_name).length + 1;
                }
                return 0;
            }
        },

        customPositionAdd() {
            return (list, i) => {
                return (i == list.length - 1) || list[i + 1].position_name != list[i].position_name;
            }
        },

        salesModelWord() {
            return {
                1: '【供货】模式下，不同用户下单其实是想向上级采购进货，各级代理可获得服务价差作为佣金奖励。',
                2: '【直销】模式下，下单人直接向平台下单，各级代理均无收益。'
            }[this.salesModel]
        }
    },

    watch: {
        id() {
            this.getProductDetail();
            this.getCustomItem();
        },

        classify() {
            this.getParamList();
            this.getAttrList();
            this.getCustomItem();
        },

        productClassify() {
            this.getParamList();
            this.getAttrList();
            this.getCustomTemp();
        },
		
		region_type() {
			if(this.region_type == 1){
				this.region_type_name ='无需配置';
			}else if(this.region_type == 2){
				this.region_type_name ='可售区域';
			}else if(this.region_type == 3){
				this.region_type_name ='不可售区域';
			}
		},

        currentCustomTemp(val) {
            if (val) {
                let data = this.customTempList.find(item => item.value == val).data.custom_item_list;
                this.customItem = data;
                this.$nextTick(() => {
                    this.currentCustomItem = Array.from(data.filter(item => item.list.length), item => item.item_id);
                })
            }
        },

        currentCustomItemData(val) {
            if (val.length) {
                if (!val.find(item => item.item_id == this.currentCustomItemTab)) {
                    this.currentCustomItemTab = val[0].item_id;
                }
            }
        },

        batchSetData(val) {
            val && this.$nextTick(() => {
                this.$refs.batchSetInput.focus();
            });
        }
    },

    mounted() {
        if (this.classify) {
            this.getParamList();
            this.getAttrList();
            this.getSpecList();
            this.getProductBrand();
            this.getFreightTmpl();
            this.getCustomTemp();
            this.initUserLevelOption(0);
        } else {
            this.initUserLevelOption();
            this.getProductDetail();
        }
		//销售区域（树形）
		this.getProductRegion();
		
        this.getCustomItem();
        this.$bus.$on('productEdit.updateFreightTmpl', () => {
            this.getFreightTmpl();
        })

        getScrollParent(this.$refs.batchSet, dom => {
            dom.addEventListener('scroll', () => {
                if (this.batchSetData && this.batchSetData.target) {
                    let rect = this.batchSetData.target.getBoundingClientRect();
                    this.batchSetData.top = rect.top + 20 + 'px';
                    this.batchSetData.left = rect.left + 'px';
                }
            });
        });
    },

    methods: {
        getParamList() {
            this.request({
                url: '/product_param/common_list',
                data: {
                    type: 1,
                    product_type_id: this.classify || this.productClassify
                },
                success: data => {
                    if (data) {
                        this.paramConfig = Array.from(data, item => {
                            item.parameter_type = item.parameter_type == 'text' ? 'input' : item.parameter_type;
                            item.parameter_values = Array.from(item.parameter_values.split(','), item => {
                                return {
                                    name: item,
                                    value: item
                                }
                            });
                            return item;
                        });

                        this.$nextTick(() => {
                            this.$refs.paramForm.set(this.paramValue);
                        });
                    }
                }
            });
        },
        getAttrList() {
            this.request({
                url: '/product_param/common_list',
                data: {
                    type: 2,
                    product_type_id: this.classify || this.productClassify
                },
                success: data => {
                    if (data) {
                        this.attrConfig = Array.from(data, item => {
                            item.parameter_type = item.parameter_type == 'text' ? 'input' : item.parameter_type;
                            item.parameter_values = Array.from(item.parameter_values.split(','), item => {
                                return {
                                    name: item,
                                    value: item
                                }
                            });
                            return item;
                        });

                        this.$nextTick(() => {
                            this.$refs.attrForm.set(this.attrValue);
                        });
                    }
                }
            });
        },
        getSpecList() {
            this.request({
                url: '/product_type/common_specs',
                data: {
                    product_type_id: this.classify || this.productClassify
                },
                success: data => {
					this.isVirtual = data.is_virtual;
					this.singleSkuMode = data.sku_modue == 1;
                    this.skuPrivateImage = data.is_support_sku_img == 1;
					this.flowList = data.order_flow_config || [];
					this.orderMaterialsOptions = (data.order_materials_json || []).map(item => {
						return {
							name: item.name,
                            remark: item.remark||item.name,
							value: item.id
						}
					});
					this.orderMaterials = this.orderMaterialsOptions.map(item => item.value);
                    this.initSpec(data.spec_list, true);
                }
            });
        },
        getProductDetail() {
            this.request({
                url: '/product/detail',
                data: {
                    product_id: this.id
                },
                loading: true,
                success: data => {
					this.singleSkuMode = data.base_info.sku_modue == 1;
                    this.productDetail = data.base_info || {};
                    this.operationMode = data.base_info.operation_mode;
                    this.productState = data.base_info.state;
                    this.productClassify = data.base_info.product_type_id;
                    this.productClassifyName = data.base_info.product_type_full_name.split(' > ');
                    this.isVirtual = data.base_info.is_virtual;
                    this.purchase_limit_type = data.base_info.purchase_limit_type;
                    this.purchase_max_count = data.base_info.purchase_limit_type == 0 ? 0 : data.base_info.purchase_max_count;
                    this.effectiveMonths = data.base_info.effective_months ? data.base_info.effective_months : 12;
                    this.expireCardRefund = data.base_info.expire_card_refund ? data.base_info.expire_card_refund : 1;
					this.region_type = data.base_info.region_type;
                    this.product_sales_model = data.base_info.sales_model;
                    this.salesModel = data.base_info.sales_model ? data.base_info.sales_model : 1;
                    this.priceModue = data.base_info.price_modue ? data.base_info.price_modue : 1;
                    this.priceUnit = data.base_info.price_unit ? data.base_info.price_unit : '';
                    this.orderMaterials = data.base_info.order_materials ? data.base_info.order_materials : '';
					this.flowList = data.base_info.order_flow_config || [];
					this.orderMaterialsOptions = (data.base_info.order_materials_json || []).map(item => {
						return {
                            name: item.name,
                            remark: item.remark||item.name,
							value: item.id
						}
					});
					this.$nextTick(() => {
						this.orderMaterials = data.base_info.order_materials ? data.base_info.order_materials.split(',') : [];
					});
					this.orderMaterialsCustom = data.base_info.custom_order_materials||'';
					
                    this.getProductBrand(data.base_info.product_brand_id);
                    this.getFreightTmpl(data.base_info.freight_template_id);
                    data.product_paramter_list.forEach(item => {
                        this.paramValue[item.parameter_id] = item.parameter_value;
                    });
                    data.product_attr_list.forEach(item => {
                        this.attrValue[item.parameter_id] = item.parameter_value;
                    });
                    let video = data.product_img_list.find(item => item.type == 2);
                    this.$refs.form.set(Object.assign({}, data.base_info, {
                        product_square_img: data.base_info.product_img_type == 1 ? data.base_info.product_img_url : '',
                        product_img_list: Array.from(data.product_img_list.filter(item => item.type == 1), item => item.image_url),
                        product_video_url: video ? video.image_url : ''
                    }));

                    if (data.base_info.product_content) {
                        try {
                            this.detailList = JSON.parse(data.base_info.product_content);
                        } catch (e) {
                        }
                    }

                    this.skuPrivateImage = data.base_info.is_support_sku_img == 1;
                    this.initSpec(data.product_spec_list);

					if (this.singleSkuMode) {
						this.skuData = data.product_sku_list[0];
					} else {
						var that = this;
						!function poll(list, tree) {
						    list.forEach(item => {
						        let specKey = tree.concat([item.group_id]);
						        if (item.children) {
						            poll(item.children, specKey);
						        } else {
						            try {
						                var image = JSON.parse(item.product_img_url) || [];
						            } catch (e) {
						                var image = Array.from(item.product_img_url ? item.product_img_url.split(',') : [], item => {
						                    return {
						                        img: item,
						                        name: ''
						                    }
						                })
						            }
						            that.$set(that.skuData, specKey.join(','), {
						                id: item.product_sku,
						                price: item.product_price,
						                stock: item.product_sku_stock,
						                // oldPrice: item.product_price_tag || '',
						                image,
						                weight: item.product_weight || '',
						                code: item.product_sku_code || ''
						            });
						        }
						    });
						}(data.product_sku_list, []);
					}

                    this.productCustom = data.base_info.is_custom;
                    this.productIsOutstock = data.base_info.is_outstock;
                }
            });
        },
        /*******加载服务品牌列表****/
        getProductBrand(id) {
            this.request({
                url: '/product_brand/options',
                data: {state: 2},
                success: data => {
                    this.productBrandOptions = Array.from(data, item => {
                        return {
                            name: item.brand_name,
                            value: item.brand_id
                        }
                    });
                    if (id) {
                        this.$nextTick(() => {
                            this.$refs.form.set({
                                product_brand_id: id
                            });
                        });
                    }
                }
            });
        },
		
		//处理树形数据，父节点选中则子节点全部选中
		handleParentCheck(data) {
		    // 处理数组（根节点列表）
		    if (Array.isArray(data)) {
		        data.forEach(node => this.handleParentCheck(node));
		        return;
		    }
		
		    // 处理单个节点（递归核心）
		    if (data && typeof data === 'object') {
		        // 子节点统一转为数组（避免 null/undefined 报错）
		        data.children = data.children || [];
		
		        // 父节点选中（chk=1）→ 所有子节点强制选中
		        if (data.chk === 1) {
		            data.children.forEach(child => {
		                child.chk = 1; // 子节点设为选中
		                this.handleParentCheck(child); // 递归处理子节点的子节点
		            });
		        } else {
		            // 父节点未选中 → 递归处理子节点（保持子节点原有状态，可选取消）
		            // 若需要“父取消子也取消”，将上面的 child.chk=1 改为 child.chk=0 即可
		            data.children.forEach(child => this.handleParentCheck(child));
		        }
		    }
		},
		
		//加载产品可售区域
		getProductRegion() {
			this.request({
				url: '/product/region',
				data: {
					product_id: this.id
				},
				loading: false,
				success: data => {
					this.handleParentCheck(data);
					this.powerList = data;
				}
			});
		},
		
        //加载运费模板列表数据
        getFreightTmpl(id) {
            this.request({
                url: '/freight_template/options',
                data:{
                    product_id:this.id||0
                },
                success: data => {
                    this.freightTmplOptions = Array.from(data, item => {
                        return {
                            name: item.option,
                            value: item.id.toString()
                        }
                    });
                    if (id) {
                        this.$nextTick(() => {
                            this.$refs.form.set({
                                freight_template_id: id
                            });
                        });
                    }
                }
            });
        },
        //插入服务详情文本
        insertDetailItem(type, item) {
            if (this.detailList.length >= 50) {
                this.$message({
                    message: '最多只能插入50条内容'
                });
                return;
            }

            if (type == 'image') {
                this.selectMedia({
                    count: 50 - this.detailList.length,
                    resolve: data => {
                        data.forEach(item => {
                            this.detailList.push({
                                type: 'image',
                                content: item
                            });
                        });
                    }
                });
            } else {
                this._editDetailText = item;
                this.detailEditText = item ? item.content : '';
                this.$refs.detailText.open();
            }
        },

        delDetailItem(i) {
            this.detailList.splice(i, 1);
        },

        insertDetailText(stop) {
            if (!this.detailEditText) {
                stop();
                this.$message({
                    message: '请填写内容'
                })
                return;
            }

            if (this._editDetailText) {
                this._editDetailText.content = this.detailEditText;
            } else {
                this.detailList.push({
                    type: 'text',
                    content: this.detailEditText
                });
            }
        },

        initSpec(data, apply) {
            this.specList = Array.from(data, spec => {
                return {
                    name: spec.group_name,
                    image: spec.group_img_flag == 2,
                    itemList: Array.from(spec.children, item => {
                        let id = apply ? `spec${this.specIndex++}` : item.group_id;
                        try {
                            var image = JSON.parse(item.group_img) || [];
                        } catch (e) {
                            var image = Array.from(item.group_img ? item.group_img.split(',') : [], item => {
                                return {
                                    img: item,
                                    name: ''
                                }
                            });
                        }

                        this.$set(this.specData, id, {
                            value: item.group_value,
                            image
                        });

                        return {
                            new: apply,
                            id
                        }
                    })
                }
            });
        },

        addSpec() {
            if (this.specList.length == 3) {
                this.$message({
                    text: '最多只能添加三个规格项'
                });
                return;
            }
            var item = {
                new: true,
                name: '',
                image: false,
                itemList: []
            };
            this.specList.push(item);
            this.addSpecItem(item);
        },

        removeSpec(index) {
            this.specList.splice(index, 1);
        },

        specValueVerify(id, list) {
            if (list.find(item => {
                return item.id != id && this.specData[item.id].value == this.specData[id].value;
            })) {
                this.$message({
                    text: '规格值不能重复，请重新输入'
                });
                this.specData[id].value = '';
            }
        },

        addSpecItem(spec) {
            var id = `spec${this.specIndex++}`;

            this.$set(this.specData, id, {
                value: '',
                image: []
            });

            spec.itemList.push({
                new: true,
                id
            });
        },

        setSpecItemImage(spec) {
            this.selectMedia({
                count: 5 - this.specData[spec.id].image.length,
                resolve: data => {
                    data = typeof data == 'string' ? [data] : data;
                    this.specData[spec.id].image = this.specData[spec.id].image.concat(Array.from(data, item => {
                        return {
                            img: item,
                            name: ''
                        }
                    }));
                }
            });
        },

        delSpecItemImage(spec, i) {
            this.specData[spec.id].image.splice(i, 1);
        },

        removeItem(spec, index) {
            spec.itemList.splice(index, 1);
        },

        batchSetSku(type, name, e) {
            let rect = e.target.getBoundingClientRect();
            this.batchSetData = {
                name,
                value: '',
                target: e.target,
                top: rect.top + 20 + 'px',
                left: rect.left + 'px',
                decimal: type == 'stock' ? 0 : 2,
                handle: data => {
                    data = parseFloat(data);
                    if (!data && data !== 0) return;
                    this.skuList.forEach(specKey => {
                        if (type != 'stock' || this.skuData[specKey].new) {
                            this.skuData[specKey][type] = data.toString();
                        }
                    });
                }
            };
        },

        batchSetCustom(type, name, custom, e) {
            let rect = e.target.getBoundingClientRect();
            this.batchSetData = {
                name,
                value: '',
                target: e.target,
                top: rect.top + 20 + 'px',
                left: rect.left + 'px',
                decimal: type == 'product_price_cost' ? 2 : 0,
                handle: data => {
                    data = parseFloat(data);
                    if (!data && data !== 0) return;
                    custom.list.forEach(item => {
                        item[type] = data.toString();
                    });
                }
            };
        },

        batchSetHandle() {
            this.batchSetData.handle(this.batchSetData.value);
            this.batchSetData = '';
        },

        setSkuImage(specKey) {
            this.selectMedia({
                count: 5 - this.skuData[specKey].image.length,
                resolve: data => {
                    data = typeof data == 'string' ? [data] : data;
                    this.skuData[specKey].image = this.skuData[specKey].image.concat(Array.from(data, item => {
                        return {
                            img: item,
                            name: ''
                        }
                    }));
                }
            });
        },

        delSkuImage(specKey, i) {
            this.skuData[specKey].image.splice(i, 1);
        },

        previewSkuImage(src) {
            src && this.$preview({
                src
            });
        },

        getCustomItem() {
            this.request({
                url: '/product/custom/info',
                data: this.classify ? {
                    product_type_id: this.classify
                } : {
                    product_id: this.id
                },
                success: data => {
                    this.customItem = data;
                    this.$nextTick(() => {
                        this.currentCustomItem = Array.from(data.filter(item => item.list.length), item => item.item_id);
                    })
                }
            });
        },

        getCustomTemp() {
            this.request({
                url: '/product/custom/template',
                data: {
                    product_type_id: this.classify || this.productClassify
                },
                success: data => {
                    if (data && data.length) {
                        this.customTempList = Array.from(data, item => {
                            return {
                                name: item.product_name,
                                value: item.product_id,
                                data: item
                            }
                        });
                    }
                }
            });
        },

        addCustomItemOption(custom, technics, index) {
            this._addCustomItem = {custom, technics, index};
            if (custom.item_type == 1) {
                let type = technics ? 'technics' : 'position';
                if (!custom[type]) {
                    this.request({
                        url: '/custom/item/param/list',
                        data: {
                            product_type_id: this.classify || this.productClassify,
                            item_id: custom.item_id,
                            type: technics ? 2 : 1
                        },
                        success: data => {
                            this.$set(custom, type, data || []);
                            this.$nextTick(() => {
                                this.addCustomItemOption(custom, technics, index);
                            });
                        }
                    })
                } else {
                    if (technics) {
                        custom.technics.forEach(item => {
                            this.$set(item, 'checked', !!custom.list.find(temp => temp.position_id == technics.position_id && temp.tech_id == item.id));
                        });
                        this.$refs.customTechnics[0].valueData = Array.from(custom.list.filter(item => item.position_id == technics.position_id), item => item.tech_id);
                        this.$refs.customTechnicsDialog[0].open();
                    } else {
                        custom.position.forEach(item => {
                            this.$set(item, 'checked', !!custom.list.find(temp => temp.position_id == item.id));
                        });
                        this.$refs.customPosition[0].valueData = Array.from(custom.list, item => item.position_id);
                        this.$refs.customPositionDialog[0].open();
                    }
                }
            } else {
                if (!custom.option) {
                    this.request({
                        url: '/custom/item/param/list',
                        data: {
                            product_type_id: this.classify || this.productClassify,
                            item_id: custom.item_id,
                            type: 3
                        },
                        success: data => {
                            this.$set(custom, 'option', data || []);
                            this.$nextTick(() => {
                                this.addCustomItemOption(custom);
                            });
                        }
                    })
                } else {
                    custom.option.forEach(item => {
                        this.$set(item, 'checked', !!custom.list.find(temp => temp.item_param_id == item.id));
                    });
                    this.$refs[`customOption${custom.item_id}`][0].valueData = Array.from(custom.list, item => item.item_param_id);
                    this.$refs[`customOptionDialog${custom.item_id}`][0].open();
                }
            }
        },

        customOptionAllCheckHandle() {
            let {custom, technics, index} = this._addCustomItem;

            if (custom.item_type == 1) {
                if (technics) {
                    this.$refs.customTechnics[0].valueData = custom.technics.map(item => item.id);
                } else {
                    this.$refs.customPosition[0].valueData = custom.position.map(item => item.id);
                }
            } else {
                this.$refs[`customOption${custom.item_id}`][0].valueData = custom.option.map(item => item.id);
            }
        },

        addCustomItemOptionHandle() {
            let {custom, technics, index} = this._addCustomItem;

            if (custom.item_type == 1) {
                if (technics) {
                    let data = this.$refs.customTechnics[0].valueData;
                    let add = [];
                    custom.technics.forEach(item => {
                        if (!item.checked && data.includes(item.id)) {
                            add.push({
                                position_id: technics.position_id,
                                position_image_url: technics.position_image_url,
                                position_name: technics.position_name,
                                tech_id: item.id,
                                tech_name: item.name,
                                min_custom_count: '1',
                                product_price_cost: '0'
                            })
                        }
                    });
                    add.length && custom.list.splice.apply(custom.list, [technics.tech_id ? index + 1 : index, technics.tech_id ? 0 : 1].concat(add));
                } else {
                    let data = this.$refs.customPosition[0].valueData;
                    custom.position.forEach(item => {
                        if (!item.checked && data.includes(item.id)) {
                            custom.list.push({
                                position_id: item.id,
                                position_image_url: item.img_url,
                                position_name: item.name,
                                tech_id: '',
                                tech_name: '',
                                min_custom_count: '1',
                                product_price_cost: '0'
                            });
                        }
                    });
                }
            } else {
                let data = this.$refs[`customOption${custom.item_id}`][0].valueData;
                custom.option.forEach(item => {
                    if (!item.checked && data.includes(item.id)) {
                        custom.list.push({
                            item_param_id: item.id,
                            param_value: item.name,
                            min_custom_count: '1',
                            product_price_cost: '0',
                            param_code: item.code
                        });
                    }
                });
            }
        },

        deleteCustomItemOption(custom, index, position) {
            if (position !== undefined) {
                if (index == 'all') {
                    custom.list.splice(custom.list.findIndex(item => item.position_id == position), custom.list.filter(item => item.position_id == position).length);
                } else {
                    if (custom.list.filter(item => item.position_id == position).length == 1) {
                        let temp = custom.list.find(item => item.position_id == position);
                        custom.list.splice(index, 1, {
                            position_id: temp.position_id,
                            position_image_url: temp.position_image_url,
                            position_name: temp.position_name,
                            tech_id: '',
                            tech_name: '',
                            min_custom_count: '1',
                            product_price_cost: '0'
                        });
                    } else {
                        custom.list.splice(index, 1);
                    }
                }
            } else {
                custom.list.splice(index, 1);
            }
        },

        submit(type) {
			let temp_region_list = [];
			!function poll(list) {
				list.forEach(item => {
					if (item.chk) {
						// 1. 父节点被勾选：只存父节点ID，不处理子节点
						temp_region_list.push(item.id);
					} else {
						// 2. 父节点未被勾选：递归处理子节点，收集子节点中被勾选的ID
						poll(item.children);
					}
				});
			}(this.powerList);
			
			if(this.region_type == 2 || this.region_type == 3){
				if(!temp_region_list.length){
					this.$message({
					    text: '请至少选择一个区域',
						icon: 'fail'
					});
					return false;
				}
			}
			
            this.$refs.form.submit({
                url: this.id ? '/product/edit' : '/product/add',
                rule: {
                    sales_model: [{
                        type: 'empty',
                        skip: () => {
                            return this.systemConfig.share_enable == 'OFF';
                        },
                        word: '请选服务择销售模式'
                    }],
                    product_name: '请填写服务标题',
					order_materials: [{
						type: 'function',
						fun: () => {
							return this.orderMaterialsCustom.trim() || this.orderMaterials.length
						},
						message: '请选择或填写购买服务所需提交材料'
					}],
                    product_itemnumber: [{
                        type: 'empty',
                        skip: () => {
                            return this.systemConfig.product_number_required == 'OFF' && this.systemConfig.product_sku_code_autocreate_type != 'productnumberseq';
                        },
                        word: '请填写服务货号'
                    }],
                    // visible_user_level: [{
                    //     type: 'empty',
                    //     skip: () => {
                    //         return this.systemConfig.share_enable == 'OFF';
                    //     },
                    //     word: '请选择服务的可售范围'
                    // }],
                    product_attr_list: [{
                        type: 'function',
                        fun: value => {
                            let attrData = this.$refs.attrForm.serialize();
                            return !this.attrConfig.find(item => {
                                return item.required_flag == 2 && !attrData[item.id];
                            });
                        },
                        word: '请填写带星号的服务属性'
                    }],
                    product_paramter_list: [{
                        type: 'function',
                        fun: value => {
                            let paramData = this.$refs.paramForm.serialize();
                            return !this.paramConfig.find(item => {
                                return item.required_flag == 2 && !paramData[item.id];
                            });
                        },
                        word: '请填写带星号的服务参数'
                    }],
                    product_img_list: [{
                        type: 'function',
                        fun: value => {
                            return value.length;
                        },
                        word: '请至少选择一张服务主图'
                    }],
                    product_square_img: [{
                        type: 'empty',
                        skip: () => {
                            return this.imageScale == 2;
                        },
                        word: '请选择服务1:1主图'
                    }],
                    spec: [{
                        type: 'function',
                        fun: () => {
                            var state = true;
                            for (let i in this.specList) {
                                if (!this.specList[i].itemList.length) {
                                    state = false;
                                    break;
                                }
                            }
                            return state;
                        },
                        word: '请添加SKU配置规格值'
                    }],
                    spec_image: [{
                        type: 'function',
                        fun: () => {
                            var state = true,
                                    spec = this.specList.find(item => item.image);

                            if (spec) {
                                for (let i in spec.itemList) {
                                    if (!this.specData[spec.itemList[i].id].image) {
                                        state = false;
                                        break;
                                    }
                                }
                            }
                            return state;
                        },
                        word: '请选择规格配图'
                    }],
                    spec_value: [{
                        type: 'function',
                        fun: () => {
                            var state = true;
                            for (let i in this.specList) {
                                for (let j in this.specList[i].itemList) {
                                    if (!this.specData[this.specList[i].itemList[j].id].value) {
                                        state = false;
                                        break;
                                    }
                                }
                            }
                            return state;
                        },
                        word: '请完善规格值'
                    }],
                    sku_config: [{
                        type: 'function',
                        fun: () => {
							if (this.singleSkuMode) {
								return (this.priceModue == 2 || this.skuData.product_price) && this.skuData.product_sku_stock;
							} else {
								var state = true;
								for (let i in this.skuList) {
								    let sku = this.skuData[this.skuList[i].join(',')];
								    if (!sku.price || isNaN(sku.price) || !sku.stock || isNaN(sku.stock)) {
								        state = false;
								        break;
								    }
								}
								return state;
							}
                        },
                        word: '请完善SKU价格及库存'
                    }],
                    sku_code: [{
                        type: 'function',
                        fun: () => {
							if (this.singleSkuMode) {
								return this.skuData.product_sku_code;
							} else {
								var state = true;
								for (let i in this.skuList) {
									let sku = this.skuData[this.skuList[i].join(',')];
									if (!sku.code) {
										state = false;
										break;
									}
								}
								return state;
							}
                        },
                        skip: () => {
                            return this.currentSkuCode == 1;
                        },
                        word: '请完善SKU编码'
                    }],
                    sku_weight: [{
                        type: 'function',
                        fun: () => {
                            var state = true;
                            for (let i in this.skuList) {
                                let sku = this.skuData[this.skuList[i].join(',')];
                                if (sku.weight && isNaN(sku.weight)) {
                                    state = false;
                                    break;
                                }
                            }
                            return state;
                        },
                        skip: () => {
                            return this.skuList.length == 0;
                        },
                        word: '服务重量信息只能输入数字'
                    }],
                    custom_item: () => {
                        if (this.productCustom == 1) {
                            if (!this.currentCustomItem.length) {
                                this.$message({
                                    text: '请选择定制项'
                                });
                                return false;
                            }

                            let custom = this.currentCustomItemData.find(custom => {
                                if (!custom.list.length) {
                                    return true;
                                }

                                return custom.list.find(item => {
                                    return (custom.item_type == 1 && !item.tech_id) || !item.product_price_cost.toString() || !item.min_custom_count.toString();
                                })
                            });

                            if (custom) {
                                this.$message({
                                    text: `请完善定制项【${custom.item_name}】`
                                });
                                return false;
                            }
                        }
                        return true;
                    },
                    auto_sell_date: [{
                        type: 'empty',
                        skip: () => {
                            return this.salesDate != 3;
                        },
                        word: '请选择上架时间'
                    }],
                    freight_template_id: [{
                        type: 'empty',
                        skip: () => {
                            return this.isVirtual != 0;
                        },
                        word: '请选择运费模板'
                    }],
                    purchase_max_count: [{
                        type: 'empty',
                        skip: () => {
                            return this.purchase_limit_type == 0;
                        },
                        word: '请设置限购数量'
                    }],
                    effective_months: [{
                        type: 'empty',
                        skip: () => {
                            return this.isVirtual == 0;
                        },
                        word: '请填写卡券有效期'
                    }]
                },

                dataFormatter: data => {
					console.log(data)
                    data.visible_user_level = this.visibleUserLevel.join(',');
                    let specList = [];
                    this.specList.forEach((spec, i) => {
                        spec.itemList.forEach((item, j) => {
                            specList.push({
                                group_id: item.id,
                                group_name: spec.name,
                                group_value: this.specData[item.id].value,
                                group_img_flag: spec.image ? 2 : 1,
                                group_img: this.specData[item.id].image,
                                group_level: i + 1,
                                sort_id: j + 1
                            });
                        });
                    });

                    let skuList = [];
					if (this.singleSkuMode) {
						skuList = [Object.assign({
							product_sku: 'sku0'
						}, this.skuData)];
					} else {
						this.skuList.forEach(specKey => {
						    let data = this.skuData[specKey.join(',')];
						    skuList.push({
						        product_sku: data.id + '',
						        product_sku_spec_ids: specKey,
						        product_sku_spec: Array.from(specKey, item => this.specData[item].value + '').join(' '),
						        product_price: isNaN(data.price) ? '' : (data.price + ''),
						        // product_price_tag: data.oldPrice + '',
						        product_sku_stock: isNaN(data.stock) ? '' : (data.stock + ''),
						        product_img_url: data.image,
						        product_weight: isNaN(data.weight) ? '' : (data.weight + ''),
						        product_sku_code: data.code + ''
						    });
						});
					}

                    data.product_id = this.id || 0;
                    data.product_img_url = this.imageScale == 1 ? data.product_square_img : data.product_img_list[0];
                    data.product_type_id = this.$route.query.classify || this.productClassify;
                    data.product_content = JSON.stringify(this.detailList);
                    data.is_support_sku_img = this.skuPrivateImage ? 1 : 0;
                    data.is_custom = this.productCustom;
                    data.purchase_limit_type = this.purchase_limit_type || 0;
                    data.purchase_max_count = this.purchase_max_count || 0;
                    data.is_outstock = this.productIsOutstock || 1;
                    data.effective_months = data.effective_months || 12;
					data.order_materials = this.orderMaterials.join(',');
					data.custom_order_materials = data.orderMaterialsCustom;

                    let paramData = this.$refs.paramForm.serialize();
                    let attrData = this.$refs.attrForm.serialize();

                    let formData = {
                        operate_type: type,
                        base_info: data,
						region_list: temp_region_list,
                        product_paramter_list: Array.from(this.paramConfig, item => {
                            return {
                                parameter_id: item.id,
                                parameter_value: typeof paramData[item.id] == 'string' ? paramData[item.id] : paramData[item.id].join(',')
                            }
                        }),
                        product_attr_list: Array.from(this.attrConfig, item => {
                            return {
                                parameter_id: item.id,
                                parameter_value: typeof attrData[item.id] == 'string' ? attrData[item.id] : attrData[item.id].join(',')
                            }
                        }),
                        product_img_list: Array.from(data.product_img_list, (item, index) => {
                            return {
                                image_url: item,
                                type: 1,
                                sort_id: index + 1
                            }
                        }).concat(data.product_video_url ? [{
                            image_url: data.product_video_url,
                            type: 2,
                            sort_id: data.product_img_list.length + 1
                        }] : []),
                        product_spec_list: specList,
                        product_sku_list: skuList,

                        is_custom: this.productCustom,
                        min_custom_count: 1,
                        custom_list: Array.from(this.currentCustomItemData, custom => {
                            return {
                                item_id: custom.item_id,
                                item_type: custom.item_type,
                                list: Array.from(custom.list, item => {
                                    return {
                                        position_id: item.position_id,
                                        tech_id: item.tech_id,
                                        item_param_id: item.item_param_id,
                                        min_custom_count: item.min_custom_count,
                                        product_price_cost: item.product_price_cost
                                    }
                                })
                            }
                        }),
                        custom_remark: data.custom_remark
                    }

                    delete data.product_paramter_list;
                    delete data.product_attr_list;
                    delete data.product_square_img;
                    delete data.product_video_url;
                    delete data.product_img_list;

                    return formData;
                },

                success: (data, param) => {
                    this.$message({
                        text: '保存成功'
                    });
                    this.$bus.$emit('productList.update', this.id ? undefined : 1);
                    this.redirectTo('/product_list');
                }
            });
        },
        //审批服务
        auditHandle(type, item) {
            //1=审批通过 2=审批驳回
            this.auditType = type;
            this.isCustom = item.is_custom;
            this._platformProfitModel = item.platform_profit_model;
            this._auditProductId = item.product_id;
            if (type == 'edit') {
                this.optionType = 2;
            } else {
                this.optionType = 1;
            }
            if (this.auditType == 1 && this.systemConfig.share_enable == 'ON' && !this.salesModel){
                this.$message({
                    text: '请选择服务销售模式',
                    icon: 'fail'
                });
                return false;
            }
            // if (this.auditType == 1 && this.systemConfig.share_enable == 'ON' && (!this.visibleUserLevel||!this.visibleUserLevel.length||this.visibleUserLevel.length==0)){
            //     this.$message({
            //         text: '请选择服务的可售范围',
            //         icon: 'fail'
            //     });
            //     return false;
            // }
            if (type == 'pass' || type == 'edit') {
                //打开设置服务SKU价格窗口
                if (item.platform_profit_model == 2 || this.systemConfig.share_enable == 'ON') {
                    //this.$refs.editProductSkuPrice.open(item);
                    this.$confirm({
                        text: '是否确认审批通过当前服务？',
                        resolve: () => {
                            this.auditProductHandle(null);
                        }
                    });
                }
            } else {
                this.$refs.auditRejectDialog.open();
            }
        },
        //审批提交
        auditProductHandle(stop) {
            if (this.auditType == 'reject') {
                stop();
                if (!this.rejectReason || this.rejectReason.length == 0){
                    this.$message({
                        text: '请填写审核驳回原因',
                        icon: 'fail'
                    });
                    return false;
                }
            }
            this.$refs.form.submit({
                url: '/product/audit',
                rule: {
                    sales_model: [{
                        type: 'empty',
                        skip: () => {
                            return this.auditType == 'reject' || this.systemConfig.share_enable == 'OFF';
                        },
                        word: '请选服务择销售模式'
                    }],
                    // visible_user_level: [{
                    //     type: 'empty',
                    //     skip: () => {
                    //         return this.auditType == 'reject' || this.systemConfig.share_enable == 'OFF';
                    //     },
                    //     word: '请选择服务的可售范围'
                    // }],
                },
                dataFormatter: data => {
                    var reject_reason = this.rejectReason;
                    if (this.rejectReasonRemark && this.rejectReasonRemark.trim()!=''){
                        reject_reason += '（';
                        reject_reason += this.rejectReasonRemark.trim();
                        reject_reason += '）';
                    }
                    return Object.assign(data, {
                        product_id: this._auditProductId,
                        audit_type: this.auditType == 'reject'?2:1,//审批状态1=通过 2=驳回
                        sales_model:this.salesModel,
                        visible_user_level:this.visibleUserLevel.join(','),
                        reject_reason:reject_reason
                    });
                },
                success: (data, res) => {
                    this.$message({
                        text: '审批成功',
                        icon: 'success'
                    });
                    //跳转待审批列表
                    this.$bus.$emit('productAuditList.update', this.id ? undefined : 1);
                    this.redirectTo('/product_audit_list');
                    if (this.auditType == 'reject'){
                        //关闭驳回原因弹窗
                        this.$refs.auditRejectDialog.close();
                    }else {
                        //跳转待审批列表
                        this.redirectTo('/product_audit_list');
                    }
                }
            });
        },
        /**
         * 加载【用户等级】列表
         * @param selectType    =0表示新增
         */
        initUserLevelOption(){
            this.request({
                url: '/user_level/options',
                data: {},
                success: data => {
                    this.userLevelOptions = Array.from(data, item => {
                        return {
                            name: item.name,
                            value: item.value
                        }
                    });
                    this.visibleUserLevel = Array.from(data, item => {
                        return item.value;
                    });
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.box {
    background: #F9F8FB;
}

.params {
    box-sizing: border-box;
    padding: 20px 20px 30px;
}

.detail {
    padding: 15px;

    &-preview {
        width: 370px;
        border: 1px solid #ddd;
        margin-right: 30px;
        background: #fff;

        dt {
            border-bottom: 1px solid #ddd;
            line-height: 40px;
            font-size: 13px;
            font-weight: bold;
            text-indent: 12px;
        }

        dd {
            height: 560px;
            overflow: auto;
            font-size: 0;

            img {
                width: 100%;
                max-height: initial;
            }

            div {
                font-size: 12px;
                line-height: 18px;
                padding: 6px 10px;
                white-space: pre-wrap;
            }
        }
    }

    &-edit {
        .tips {
            line-height: 40px;
            font-size: 12px;
            color: #666;

            b {
                font-weight: bold;
                color: #f00;
            }
        }

        &-item {
            position: relative;
            box-sizing: border-box;
            width: 100px;
            height: 100px;
            border: 1px solid #ddd;
            margin-right: 12px;
            margin-bottom: 12px;
            background: #fff;

            &.insert {
                border: none;
                background: none;

                .c-button {
                    margin: 5px 0;
                }
            }

            .text {
                align-self: flex-start;
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                padding: 6px 10px;

                p {
                    height: 100%;
                    overflow: hidden;
                    line-height: 18px;
                    font-size: 12px;
                    word-break: break-all;
                    white-space: pre-wrap;
                }
            }

            .handle {
                position: absolute;
                right: 1px;
                bottom: 1px;

                a {
                    width: 18px;
                    line-height: 18px;
                    font-size: 12px;
                    text-align: center;
                    color: #fff;
                }
            }
        }
    }

    &-text-edit {
        padding: 20px;

        textarea {
            box-sizing: border-box;
            width: 100%;
            height: 150px;
            border: 1px solid #ddd;
            padding: 10px 14px;
            line-height: 20px;
            resize: none;
        }
    }

    &-table {
        width: 100%;

        thead {
            background: #F9F9F9;
        }

        tbody {
            background: #fff;
        }

        th, td {
            width: 100px;
            height: 40px;
            padding: 0 10px;
            line-height: 40px;
            border: 1px solid #ddd;
            color: #444;
            font-size: 12px;
            text-align: left;
        }

        th {
            b {
                margin-right: 5px;
                color: #f00;
            }

            a {
                margin-left: 5px;
            }
        }

        td {
            position: relative;

            .c-input {
                height: 30px;
                border: none;
            }
        }
    }
}

.batch-set {
    position: fixed;
    padding: 0 11px 17px;
    margin-top: -100px;
    background: #fff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);

    p {
        line-height: 43px;
        font-size: 13px;
        font-weight: bold;
    }

    >>> .c-input {
        width: 100px;
        height: 28px;
        padding: 0 5px;
        margin-right: 5px;
    }
}

.spec {
    position: relative;
    padding: 15px 17px;

    &:nth-child(n+2) {
        margin-top: 16px;
    }

    &-list {
        box-sizing: border-box;
        border: 1px dotted #ddd;
        padding: 14px;

        .c-button {
            margin-top: 16px;
        }
    }

    &-label {
        margin-right: 8px;
        line-height: 36px;
        font-size: 13px;
        white-space: nowrap;
        color: #444;
    }

    &-remove {
        position: absolute;
        right: 0;
        top: 0;
        width: 24px;
        line-height: 24px;
        font-size: 12px;
        text-align: center;
        color: #fff;
        background: #aaa;

        &:hover {
            background: #999;
        }
    }

    &-name {
        margin-right: 10px;
        line-height: 36px;
        font-size: 13px;
    }

    .c-checkbox {
        margin-top: 0;
    }

    &-item {
        border: 1px solid #ddd;
        padding: 5px;
        background: #fff;

        &.z-dis {
            background: #f5f5f5;
        }

        &-img {
            z-index: 1;
            position: relative;
            margin-right: 5px;
            width: 40px;
            min-width: 40px;
            height: 40px;
            color: #bbb;
            background: #fff;

            .main {
                height: 100%;
                cursor: pointer;

                &:hover {
                    p {
                        display: none;
                    }

                    .delete {
                        display: flex;
                    }
                }

                p {
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    padding: 0 5px;
                    line-height: 16px;
                    font-size: 12px;
                    text-align: center;
                    color: #fff;
                    background: rgba(0, 0, 0, .6);
                }

                .delete {
                    display: none;
                    position: absolute;
                    inset: 0;
                    color: #fff;
                    background: rgba(0, 0, 0, .6);
                }
            }

            .preview {
                position: relative;
                padding: 10px;
                background: rgba(0, 0, 0, .8);

                &:before {
                    content: '';
                    position: absolute;
                    left: 14px;
                    top: -6px;
                    border-width: 0 6px 6px 6px;
                    border-style: solid;
                    border-color: rgba(0, 0, 0, .8) rgba(0, 0, 0, 0);
                }

                &-box {
                    position: absolute;
                    left: 0;
                    top: 100%;
                    padding-top: 10px;
                }

                .image {
                    width: 180px;
                    height: 180px;
                    border: none;
                }

                .input {
                    width: 100%;
                    height: 28px;
                    border: none;
                    margin-top: 6px;
                }
            }

            .preview {
                position: relative;
                padding: 10px;
                background: rgba(0, 0, 0, .8);

                &:before {
                    content: '';
                    position: absolute;
                    left: 14px;
                    top: -6px;
                    border-width: 0 6px 6px 6px;
                    border-style: solid;
                    border-color: rgba(0, 0, 0, .8) rgba(0, 0, 0, 0);
                }

                &-box {
                    position: absolute;
                    left: 0;
                    top: 100%;
                    padding-top: 10px;
                }

                .image {
                    width: 180px;
                    height: 180px;
                    border: none;
                }

                .input {
                    height: 28px;
                    border: none;
                    margin-top: 6px;
                }
            }
        }

        &-value {
            width: 80px;
            height: 20px;
            font-size: 13px;

            &:disabled {
                cursor: not-allowed;
            }
        }

        &-remove {
            margin-left: 5px;
            font-size: 16px;
            color: #C70000;
        }
    }

    .c-button {
        margin-top: 16px;
    }
}

.sku-detail {
    position: relative;

    .sku-image {
        padding: 5px 0;

        .image {
            position: relative;
            width: 40px;
            height: 40px;
            font-size: 12px;
            cursor: pointer;

            &:nth-child(n+2) {
                margin-left: 5px;
            }

            .main {
                position: relative;
                box-sizing: border-box;
                height: 100%;
                border: 1px dotted #ccc;
                color: #ccc;

                &:hover {
                    border-color: #999;
                    color: #999;

                    p {
                        display: none;
                    }

                    .delete {
                        display: flex;
                    }
                }

                p {
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    padding: 0 5px;
                    line-height: 16px;
                    font-size: 12px;
                    text-align: center;
                    color: #fff;
                    background: rgba(0, 0, 0, .6);
                }

                .delete {
                    display: none;
                    position: absolute;
                    inset: 0;
                    color: #fff;
                    background: rgba(0, 0, 0, .6);
                }
            }

            .preview {
                z-index: 1;
                position: relative;
                padding: 10px;
                background: rgba(0, 0, 0, .8);

                &:before {
                    content: '';
                    position: absolute;
                    left: 10px;
                    top: -6px;
                    border-width: 0 6px 6px 6px;
                    border-style: solid;
                    border-color: rgba(0, 0, 0, .8) rgba(0, 0, 0, 0);
                }

                &-box {
                    position: absolute;
                    left: 0;
                    top: 100%;
                    padding-top: 10px;
                }

                .image {
                    width: 180px;
                    height: 180px;
                    border: none;
                }

                .input {
                    width: 100%;
                    height: 28px;
                    border: none;
                    margin-top: 6px;
                }
            }
        }
    }

    .total {
        padding: 0 13px;
        line-height: 50px;
        font-size: 12px;
        color: #666;
        background: #F9F9F9;
    }
}

.custom-detail {
    .custom-item {
        li {
            border: 1px solid #ddd;
            padding: 0 10px;
            margin-right: -1px;
            line-height: 36px;
            font-size: 13px;
            color: #000;
            background: #fff;
            cursor: pointer;

            &:hover {
                position: relative;
            theme-border(lesser);
            theme-color(lesser);
            }

            &.z-crt {
                position: relative;
            theme-border(lesser);
                color: #fff;
            theme-background(lesser);
            }
        }
    }

    .detail-table {
        margin: -1px 0 12px;

        .position {
            padding-top: 10px;

            &-image {
                width: 60px;
                height: 60px;
            }

            p {
                line-height: 30px;
            }
        }

        .color {
            > div {
                border: 1px solid #eee;
                padding: 4px;
                margin-right: 6px;

                div {
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .remove {
            font-size: 12px;
            color: #f00;
        }
    }

    .custom-option {
        padding: 10px 24px;
        line-height: 34px;

        .c-button {
            margin-bottom: 10px;
        }

        .position {
            border: 1px solid #eee;

            &-list {
                gap: 15px;
            }

            &-image {
                width: 120px;
                height: 120px;
                border: none;
            }

            &-check {
                border-top: 1px solid #eee;
                padding: 7px 8px;
                background: #FAFAFA;
            }
        }
    }
}
>>> .power {
		max-height: 500px;
		border: 1px solid #ddd;
		overflow: auto;
			
		&-list {
			margin-left: 40px;
			overflow: hidden;
		}
		
		> &-item {
			margin-left: 10px;
			&:nth-child(1) {
				margin-top: 10px;
			}
			&:nth-last-child(1) {
				margin-bottom: 15px;
			}
		}
		
		&-item {
			margin-top: 3px;
			margin-right: 20px;
		}
	}
	
	
	
	>>> .m-node-list {
		li {
			&:before {
				background: #007fff !important;
			}
			
			.dot {
				border-color: #007fff !important;
				background: #007fff !important;
			}
			
			p {
				color: #000 !important;
			}
		}
	}

	.materials {
		box-sizing: border-box;
		max-width: 900px;
		border: 1px solid #ddd;
		padding: 8px 16px;
		margin-top: 10px;
		line-height: 26px;
		white-space: pre-wrap;
		background: #FAFAFA;
	}
</style>